define('components/hotspot/collections/hotspot',[
    'components/hotspot/models/hotspot'
], function(HotspotModelClass) {
    "use strict";

    return Backbone.Collection.extend({
        "model": HotspotModelClass
    });
});

